import Swiper from '../../../../node_modules/swiper/swiper-bundle.mjs';

export const initBrandsAllSlider = function() {
  const sliderBrandsAll = document.querySelector('[data-slider-brands-all="container"]');
  if (!sliderBrandsAll) {
    return;
  }

  const swiperBrandsAll = function() {
    new Swiper(sliderBrandsAll, {
      spaceBetween: 10,
      slidesPerView: 3,
      slidesPerGroup: 3,
      pagination: {
        el: '[data-slider-brands-all="pagination"]',
        clickable: true,
        dynamicBullets: true
      },
      navigation: {
        nextEl: '[data-slider-brands-all="arrow-next"]',
        prevEl: '[data-slider-brands-all="arrow-prev"]'
      },
      breakpoints: {
        768: {
          sliderPerGroup: 1,
          slidesPerView: 7,
          spaceBetween: 6
        },
        1500: {
          slidesPerView: 7,
          spaceBetween: 36
        }
      }
    });
  }
  swiperBrandsAll();
};
